export type CaseStudy = {
  slug: string;
  title: string;
  sector: string;
  year: string;
  client: string;
  location: string;
  lead: string;
  scope: string;
  summary: string;
  challenge: string;
  solution: string;
  results: string[];
  expertise: string[];
  image: string;
  featured: boolean;
};

export const caseSectors = [
  'Tous les secteurs',
  'Agro-industrie',
  'Énergie',
  'Cimenterie',
  'Mines & carrières',
  'Pétrole & gaz',
  'Logistique portuaire',
  'BTP & infrastructures',
  'Industries manufacturières',
];

export const caseStudies: CaseStudy[] = [
  {
    slug: 'cuves-stockage-agro',
    title: 'Cuves de stockage process',
    sector: 'Agro-industrie',
    year: '2025',
    client: 'Groupe agro-industriel',
    location: 'Douala, zone industrielle',
    lead: 'Chaudronnerie & soudure',
    scope: '6 semaines · 4 cuves de 12 m³',
    summary:
      "Fabrication en atelier de quatre cuves inox alimentaires, avec piquages, trappes de visite et supportage, livrées et installées sans arrêter la ligne de production.",
    challenge:
      "La ligne tournait en continu : l'installation devait se faire par fenêtres d'intervention très courtes, avec un état de surface intérieur compatible contact alimentaire.",
    solution:
      "Préfabrication complète à Logbaba, contrôle dimensionnel avant départ, puis montage de nuit en deux séquences. Les soudures intérieures ont été réalisées en TIG avec purge argon et passivation des cordons.",
    results: [
      '4 cuves livrées conformes au premier contrôle',
      'Aucune heure de production perdue',
      'Étanchéité validée à 100 % au test hydraulique',
    ],
    expertise: ['Chaudronnerie industrielle', 'Soudure industrielle', 'Montage d’ouvrages industriels'],
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.05.26.jpeg',
    featured: true,
  },
  {
    slug: 'reseau-vapeur-energie',
    title: 'Réseau de tuyauterie vapeur',
    sector: 'Énergie',
    year: '2025',
    client: 'Producteur d’énergie thermique',
    location: 'Bonabéri, Douala',
    lead: 'Tuyauterie & supportage',
    scope: '9 semaines · 480 ml de réseau',
    summary:
      "Reprise complète d'un réseau vapeur haute pression : isométriques, préfabrication, calorifuge et mise en service, avec compensation de dilatation recalculée.",
    challenge:
      "Le réseau existant subissait des contraintes thermiques mal absorbées, provoquant des fuites récurrentes et des arrêts de chauffe non planifiés.",
    solution:
      "Relevé sur site, modélisation des dilatations, ajout de lyres et remplacement des supports fixes. Tronçons préfabriqués en atelier, repérés et montés par séquence pour limiter le temps de soudage en hauteur.",
    results: [
      '480 ml de tuyauterie remplacés',
      'Fin des arrêts de chauffe liés aux fuites',
      'Pentes et points de purge vérifiés un par un',
    ],
    expertise: ['Tuyauterie industrielle', 'Soudure industrielle', 'Maintenance industrielle'],
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.05.27.jpeg',
    featured: false,
  },
  {
    slug: 'charpente-cimenterie',
    title: 'Charpente de convoyeur',
    sector: 'Cimenterie',
    year: '2024',
    client: 'Site de production cimentier',
    location: 'Littoral, Cameroun',
    lead: 'Structures métalliques',
    scope: '5 semaines · 34 t d’acier',
    summary:
      "Étude d'exécution et fabrication d'une charpente support de convoyeur, avec passerelles de maintenance et garde-corps, montée en arrêt technique programmé.",
    challenge:
      "Une portée de 18 mètres sans appui intermédiaire, dans une ambiance très poussiéreuse, avec un accès engin limité sur la zone de montage.",
    solution:
      "Découpage des tronçons en trois modules levables, contreventement provisoire, boulonnage HR et contrôle de flèche après mise en charge.",
    results: [
      '34 tonnes assemblées et boulonnées',
      'Flèche mesurée inférieure au seuil d’étude',
      'Montage terminé avant la fin de l’arrêt',
    ],
    expertise: ['Chaudronnerie industrielle', 'Montage d’ouvrages industriels', 'Peinture industrielle'],
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.04.28.jpeg',
    featured: true,
  },
  {
    slug: 'silo-stockage-mines',
    title: 'Silo de stockage minier',
    sector: 'Mines & carrières',
    year: '2024',
    client: 'Exploitant de carrière',
    location: 'Région du Centre',
    lead: 'Chaudronnerie lourde',
    scope: '8 semaines · silo 80 m³',
    summary:
      "Conception et fabrication d'un silo de stockage avec trémie de décharge, échelle à crinoline et plateforme de chargement, livré monté sur site.",
    challenge:
      "Le site est éloigné des grands axes : il fallait un ouvrage démontable en éléments transportables par camion 6×4, sans grue de forte capacité.",
    solution:
      "Viroles roulées en sections boulonnables, renforts raidisseurs, plan de levage adapté aux moyens du site. Assemblage et serrage contrôlé par notre équipe.",
    results: [
      'Silo monté en 9 jours sur site',
      'Aucun élément hors gabarit transport',
      'Étanchéité et verticalité contrôlées à la réception',
    ],
    expertise: ['Chaudronnerie industrielle', 'Montage d’ouvrages industriels', 'Import / Export'],
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-03-at-10.58.51.jpeg',
    featured: false,
  },
  {
    slug: 'arret-technique-petrole',
    title: 'Arrêt technique programmé',
    sector: 'Pétrole & gaz',
    year: '2025',
    client: 'Opérateur pétrolier',
    location: 'Zone portuaire, Douala',
    lead: 'Maintenance & HSE',
    scope: '11 jours · 18 intervenants',
    summary:
      "Renfort d'équipes pendant un arrêt de maintenance : reprises de soudures, remplacement de tronçons, réhabilitation de supports et contrôles avant remise en service.",
    challenge:
      "Fenêtre d'intervention de onze jours seulement, en zone ATEX, avec coactivité forte et permis feu strict à obtenir chaque matin.",
    solution:
      "Une équipe dédiée de 18 compagnons en deux rotations, permis et analyses de risques préparés la veille, poste de coordination sur site et reporting quotidien.",
    results: [
      'Toutes les tâches terminées dans la fenêtre',
      'Zéro incident déclaré sur la période',
      'Dossier de réception remis le dernier jour',
    ],
    expertise: ['Maintenance industrielle', 'Soudure industrielle', 'Placement du personnel'],
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/ca84cb971abbca8924ed01dd0a41.jpeg',
    featured: false,
  },
  {
    slug: 'portique-portuaire',
    title: 'Portique de manutention',
    sector: 'Logistique portuaire',
    year: '2024',
    client: 'Opérateur logistique portuaire',
    location: 'Port de Douala',
    lead: 'Structures & anticorrosion',
    scope: '7 semaines · 12 t d’acier',
    summary:
      "Fabrication d'un portique de manutention sur mesure avec chemin de roulement, puis traitement anticorrosion renforcé pour ambiance saline.",
    challenge:
      "Ambiance marine agressive et contraintes de charge roulante : la structure devait conserver sa géométrie sous passage répété des équipements.",
    solution:
      "Profilés dimensionnés pour la charge roulante, goussets renforcés, soudure continue, sablage et système peinture trois couches adapté au sel.",
    results: [
      'Géométrie conforme au gabarit exigé',
      'Système peinture contrôlé en épaisseur',
      'Mise en service sans reprise',
    ],
    expertise: ['Chaudronnerie industrielle', 'Peinture industrielle', 'Montage d’ouvrages industriels'],
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/metal-painting2-687x318-1.jpg',
    featured: false,
  },
  {
    slug: 'anticorrosion-btp',
    title: 'Réhabilitation anticorrosion',
    sector: 'BTP & infrastructures',
    year: '2025',
    client: 'Entreprise de travaux publics',
    location: 'Douala & environs',
    lead: 'Peinture industrielle',
    scope: '4 semaines · 1 200 m²',
    summary:
      "Reprise complète de la protection anticorrosion d'ouvrages métalliques exposés : décapage, application multicouche et contrôle d'épaisseur.",
    challenge:
      "Ouvrages déjà corrodés, en service, avec impossibilité de démontage et des surfaces difficiles d'accès au-dessus des voies circulées.",
    solution:
      "Préparation mécanique par brossage et sablage localisé, application au pinceau et au pistolet selon accessibilité, avec échafaudage roulant et balisage permanent.",
    results: [
      '1 200 m² traités en quatre semaines',
      'Épaisseur sèche conforme sur chaque zone',
      'Aucune gêne durable à la circulation',
    ],
    expertise: ['Peinture industrielle', 'Monteur échafaudage', 'Maintenance industrielle'],
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.05.23.jpeg',
    featured: false,
  },
  {
    slug: 'tuyauterie-manufacture',
    title: 'Tuyauterie process d’atelier',
    sector: 'Industries manufacturières',
    year: '2024',
    client: 'Unité de transformation',
    location: 'Douala, Bassa',
    lead: 'Tuyauterie & soudure',
    scope: '5 semaines · 3 lignes process',
    summary:
      "Mise en conformité de trois lignes process : remplacement de tronçons, ajout de vannes, reprise de supportage et identification des circuits.",
    challenge:
      "Les lignes étaient modifiées au fil des ans sans plan à jour : il fallait reconstituer l'existant avant de pouvoir proposer une remise en ordre.",
    solution:
      "Relevé complet et isométriques de l'existant, priorisation des points critiques, intervention ligne par ligne pour maintenir la production.",
    results: [
      'Trois lignes remises en conformité',
      'Plans à jour remis au client',
      'Production maintenue pendant les travaux',
    ],
    expertise: ['Tuyauterie industrielle', 'Maintenance industrielle', 'Chaudronnerie industrielle'],
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.39.37-1.jpeg',
    featured: false,
  },
];

export const caseFigures = [
  { value: 8, suffix: '', label: 'Chantiers documentés', hint: 'Études de cas détaillées' },
  { value: 8, suffix: '', label: 'Secteurs industriels', hint: 'Du port à la cimenterie' },
  { value: 100, suffix: '%', label: 'Ouvrages réceptionnés', hint: 'Contrôle avant mise en service' },
  { value: 2, suffix: '', label: 'Bassins d’intervention', hint: 'Cameroun & sous-région' },
];